import { getConfig } from '@/js/helpers/config'
import { trackEvent } from '@/js/tools/amplitude'
import axios, { AxiosError } from 'axios'

const affiliate = (): void => {
  const appUrl = getConfig('BRIGHTERLY_APP_URL')
  if (!appUrl) throw new Error('appUrl is not defined')
  const searchParams = new URLSearchParams(window.location.search)
  const stringParams = searchParams.toString()
  if (stringParams) {
    const requestUrl = `${appUrl}/booking/simple/start?${stringParams}`
    axios.post(requestUrl, null, { withCredentials: true })
      .then((): void => {
        trackEvent('Request_success', { feature: 'affiliate', name: 'affiliate_request' })
      })
      .catch((error: AxiosError): void => {
        trackEvent('Request_error', {
          feature: 'affiliate',
          name: 'affiliate_request',
          error_code: error.response?.status ?? error.code ?? null,
          error_message: error.message
        })
      })
  }
}

affiliate()
